import React from "react";
import styled from "styled-components";
import { getImageMaxWidthUrl, getGifUrl } from "../../utilities";

const Image = styled.img`
  max-width: 100%;
  display: block;
`;

const Picture = styled.picture``;

const ImageWrapper = styled.figure`
  display: grid;
  justify-content: center;
  left: 50%;
  margin: var(--gutter) 0;
  max-width: 100%;
  padding: 0 var(--gutter);
  position: relative;
  transform: translateX(-50%);
  width: 100vw;
`;

const ImageCaption = styled.figcaption`
  text-align: right;
  font-size: 12px;
  margin-top: 10px;
`;

class Figure extends React.Component {
  render() {
    const responsiveSizes = [300, 600];
    return (
      <ImageWrapper>
        {this.props["data-extension"] === ".gif" ? (
          <Picture>
            <Image
              alt={this.props["data-alt"]}
              title={this.props["data-title"]}
              src={getGifUrl(this.props["data-id"])}
            />
          </Picture>
        ) : (
          <Picture>
            {responsiveSizes.map(s => (
              <source
                key={`${this.props["data-id"]}---${s}`}
                media={`(max-width: ${s}px)`}
                srcSet={getImageMaxWidthUrl(this.props["data-id"], s)}
              />
            ))}
            <Image
              alt={this.props["data-alt"]}
              title={this.props["data-title"]}
              src={getImageMaxWidthUrl(this.props["data-id"], 960)}
            />
          </Picture>
        )}
        {this.props["data-caption"] ? (
          <ImageCaption>{this.props["data-caption"]}</ImageCaption>
        ) : null}
      </ImageWrapper>
    );
  }
}

export default Figure;
